module.exports = __webpack_public_path__ + "static/media/Sign up_PmPOS-V6.291295bd.jpg";